import React from 'react';
import NumberRating from '../../UI/NumberRating';
import StarRating from '../../UI/StarRating';
import { NepaliDatePicker } from 'nepali-calander';
import '../../../assets/scss/_dynamicform.scss';

const ViewSubmittedForm = ({ selectedResponse }) => {
  const answers = selectedResponse?.answers?.filter(a => a.category === 'question') || [];
  const sections = selectedResponse?.answers?.filter(a => a.category === 'section') || [];

  return (
    <div className="df-view">
      <div className="df-view__wrapper">

        {/* Meta card */}
        <div className="df-view__meta-card">
          <h2>{selectedResponse?.title || "Untitled Form"}</h2>
          {selectedResponse?.description && (
            <p>{selectedResponse.description}</p>
          )}
          <hr />
          <div className="df-view__meta-grid">
            <div className="df-view__meta-item">
              <div className="df-view__meta-label">Submitted By</div>
              <div className="df-view__meta-value">{selectedResponse?.submittedByName || "—"}</div>
            </div>
            <div className="df-view__meta-item">
              <div className="df-view__meta-label">Submitted At</div>
              <div className="df-view__meta-value">
                {selectedResponse?.submittedAt
                  ? new Date(selectedResponse.submittedAt).toLocaleString()
                  : "—"}
              </div>
            </div>
            <div className="df-view__meta-item">
              <div className="df-view__meta-label">Evaluated To</div>
              <div className="df-view__meta-value">{selectedResponse?.evaluationTo || "—"}</div>
            </div>
            <div className="df-view__meta-item">
              <div className="df-view__meta-label">Subject</div>
              <div className="df-view__meta-value">{selectedResponse?.evaluationSubjectName || "—"}</div>
            </div>
            <div className="df-view__meta-item">
              <div className="df-view__meta-label">Points Obtained</div>
              <div className="df-view__meta-value">
                {selectedResponse?.obtainedPoints
                  ? `${selectedResponse.obtainedPoints.toFixed(1)} / 5`
                  : "—"}
              </div>
            </div>
            {selectedResponse?.nextTermTarget && (<div className="df-view__meta-item">
              <div className="df-view__meta-label">Next Term Target</div>
              <div className="df-view__meta-value badge rounded-pill px-2 py-1" style={{ background: "#f0f9ff", color: "#0369a1", fontSize: "0.72rem", fontWeight: 600 }}>
                {selectedResponse?.nextTermTarget}%
              </div>
            </div>)}
          </div>
        </div>

        {/* Sections */}
        {sections.map((it, i) => (
          <div key={i} className="df-view__section-card">
            <div className="df-view__section-title">{it?.label || "Untitled"}</div>
            {it?.description && (
              <div className="df-view__section-desc">{it.description}</div>
            )}
          </div>
        ))}

        {/* Questions */}
        {answers.map((it, i) => (
          <div key={it?.id || i} className="df-view__question-card">
            <label className="df-view__question-card__label">
              {it?.label || "Untitled Question"}
            </label>

            {it?.type === 'short_answer' && (
              <div className={`df-view__question-card__text-value${!it?.textValue ? " df-view__question-card__text-value--empty" : ""}`}>
                {it?.textValue || "—"}
              </div>
            )}

            {it?.type === 'paragraph' && (
              <div className={`df-view__question-card__text-value${!it?.textValue ? " df-view__question-card__text-value--empty" : ""}`}
                style={{ whiteSpace: "pre-wrap" }}>
                {it?.textValue || "—"}
              </div>
            )}

            {it?.type === 'multiple_choice' && (
              <div className="df-view__choice-list">
                {it?.options?.map(opt => (
                  <div key={opt.id} className="df-view__choice-row">
                    <input type="radio" name={it?.id} checked={it?.textValue === opt.id} disabled readOnly />
                    <span>{opt.text}</span>
                  </div>
                ))}
              </div>
            )}

            {it?.type === 'checkboxes' && (
              <div className="df-view__choice-list">
                {it?.options?.map(opt => (
                  <div key={opt.id} className="df-view__choice-row">
                    <input type="checkbox" checked={(it?.textValue || []).includes(opt.id)} disabled readOnly />
                    <span>{opt.text}</span>
                  </div>
                ))}
              </div>
            )}

            {it?.type === 'dropdown' && (
              <select className="df-select" value={it?.textValue || ""} disabled>
                <option value="" disabled>Choose</option>
                {it?.options?.map(opt => (
                  <option key={opt.id} value={opt.id}>{opt.text}</option>
                ))}
              </select>
            )}

            {it?.type === 'number' && (
              <NumberRating disabled keyId={it?.id} value={it?.numericValue || 0} max={it?.maxNumber || 5} />
            )}

            {it?.type === 'rating' && (
              <StarRating disabled value={it?.numericValue || 0} max={it?.maxNumber || 5} />
            )}

            {it?.type === 'date' && (
              <NepaliDatePicker disabled value={it?.textValue || ''} showToggle={true} />
            )}
          </div>
        ))}

      </div>
    </div>
  );
};

export default ViewSubmittedForm;